module.exports = __webpack_public_path__ + "static/img/ec.89c78367.svg";